import { render } from "./AdjustmentDetail.vue?vue&type=template&id=68b4e37e"
import script from "./AdjustmentDetail.vue?vue&type=script&lang=js"
export * from "./AdjustmentDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__